import React from 'react'
import Navbar from '../components/Navbar'
import bg1 from '../assets/bg-kfirmowe.jpg'
import Footer from '../components/Footer'
import {rodzaje} from '../components/KredytyFirmoweItems'


function KredytyFirmowe() {
  return (
    <div>
    <Navbar />
    <div className='pt-20 flex justify-center mx-auto static'>
        <div className='bg-white bg-opacity-90 absolute mx-auto justify-center mt-32 max-w-[450px] text-center py-4 rounded-xl px-2'>
          <h3 className='uppercase text-xl md:text-3xl font-semibold pb-2'>Kredyty Firmowe</h3>
        </div>
      <img src={bg1} alt="background photo" className='w-screen h-96 object-cover'/>
    </div>
    
    <div className='max-w-[1240px] bg-white mx-auto justify-center text-center'>
    <div className='pt-10 px-32'>
      <h4 className='font-semibold text-lg md:text-xl'>Chcesz rozwijać swoją działalność i osiągnąć większe zyski?</h4>
      <p className='pt-2'>Nie ma problemu, kredyt firmowy Ci to umożliwi. Jest wiele możliwości wsparcia, wystarczy tylko wybrać odpowiednie rozwiązanie. Spotkanie z ekspertem pozwoli wskazać jakie rozwiązanie będzie dla Ciebie najlepsze.</p>
    </div>
    <div className='pt-10'>
        <h3 className='text-xl md:text-3xl font-bold'>Rodzaje finansowania</h3>
        <div className='pt-4 gap-3 grid md:grid-cols-2 px-20'>
          {rodzaje.map((item) => (
            <div key={item.id} className='px-5 pt-4'>
              <h4 className='font-semibold text-lg md:text-xl'>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    <Footer />
    </div>  
    </div>
  )
}

export default KredytyFirmowe